// const SMALL_BAG = 3.5;
// const LARGE_BAG = 10;

import {formatAddress} from "@/store/utils";


// const SNACKS = 0.5;
// const SMALL_MEAL = 0.83;
// const REGULAR_MEAL = 1;
const QRCode = require('qrcode');
const md5 = require('md5');

const QRCodeSize = 200;
export default class BagCalc {
  static QRCodeSize() {
    return QRCodeSize
  }

  static async generateQRCodes(qrCodeValue, {size = null}) {
    return QRCode.toDataURL(qrCodeValue, {type: 'svg', width: size || QRCodeSize, height: size || QRCodeSize});
  }

  // box bins are colour-named (e.g. "Blue.A-11", "Temp Ash.A-12"); regular
  // "shoebox" rack bins (Alfa-11, Bravo-12, ...) are not. Rack configs that
  // use stickersPerBox must be named with one of these colour words or their
  // bins fall back to volume-based counting
  static isBoxBinName(bin) {
    return /(Green|Blue|Grey|Yellow|Ash|Charcoal|Purple|Red)/.test(bin);
  }

  // stickers for one box bin: exact match on the rack-name portion (before
  // ".Letter-Number") so "Yellow Split.A-11" matches only a "Yellow Split"
  // config, never "Yellow"; shoebox bins (no ".") and unknown racks return 1
  static stickersPerBoxFor(bin, rackConfigs) {
    if (!rackConfigs || !rackConfigs.length) {
      return 1;
    }
    const parts = (bin || '').split('.');
    if (parts.length < 2) {
      return 1;
    }
    const rackName = parts[0].trim();
    const config = rackConfigs.find(c => c.boxType === rackName);
    const stickers = config && Number(config.stickersPerBox);
    return stickers >= 1 ? stickers : 1;
  }

  // TODO: this whole calculation should move to the api server (fed-nutrition-api
  // assignBins.ts) so the box count is decided alongside bin assignment and
  // stored on the order, instead of being re-derived here from bin strings.
  //
  // each colour-named box bin is one physical box and needs its own sticker
  // and QR code (split orders occupy two boxes); shoebox bins have no 1:1
  // box-to-sticker mapping so they keep the volume-based count. Volume still
  // wins when one big box order needs more stickers than it has bins.
  static getStickerCount(orders, rackConfigs) {
    const volumeCount = BagCalc.getNumberOfBags(orders);
    const boxStickerCount = BagCalc.getBins(orders)
      .filter(b => BagCalc.isBoxBinName(b))
      .reduce((sum, b) => sum + BagCalc.stickersPerBoxFor(b, rackConfigs), 0);
    return Math.max(boxStickerCount, volumeCount);
  }

  static computeBags(groupedByCustomer, rackConfigs) {
    const driverCounts = {};
    const customerLabels = Object.keys(groupedByCustomer).map((customerName, index) => {
      const orders = groupedByCustomer[customerName];
      const bins = BagCalc.getBins(orders);
      const boxBins = bins.filter(b => BagCalc.isBoxBinName(b));
      const boxStickerCount = boxBins.reduce((sum, b) => sum + BagCalc.stickersPerBoxFor(b, rackConfigs), 0);
      const count = Math.max(boxStickerCount, BagCalc.getNumberOfBags(orders));
      // one bin name per sticker, in bin-sorted order, repeating multi-sticker
      // boxes; only meaningful when every sticker maps to exactly one box —
      // volume-driven extras or shoebox bins leave it null (every bin is then
      // shown on every sticker)
      let binsPerSticker = null;
      if (bins.length > 0 && boxBins.length === bins.length && count === boxStickerCount) {
        binsPerSticker = bins.flatMap(b => Array(BagCalc.stickersPerBoxFor(b, rackConfigs)).fill(b));
      }
      // the meal units the bag count is derived from, kept on the label so it
      // can be shown and filtered on without recomputing from the orders
      const mealCount = BagCalc.getSizeValue(orders);
      const driver = orders[0].driver;
      const eta = orders[0].eta || orders[0].ship_date;
      const address = formatAddress(orders[0].address, {short: true});
      driverCounts[driver] = driverCounts[driver] || 0;
      driverCounts[driver] += count;
      const qrCodeValues = BagCalc.generateQRValues(customerName, {count});
      return {
        eta,
        customerName: customerName,
        driver,
        bins,
        binsPerSticker,
        qrCodeValues,
        count,
        mealCount,
        bagSize: BagCalc.getSizeOfBags(orders),
        sequence: index + 1,
        address_line_1: address.split(',')[0],
        address_line_2: address.split(',').slice(1).join(', ')
      }
    })
    return {driverCounts, customerLabels};
  }

  static generateQRValues(qrBase, {count, orders, rackConfigs}) {
    // strip base into just letters (ignore *, spaces, case changes)
    qrBase = qrBase.replace(/\W/g, '').toLowerCase();
    if (!count && orders) {
      count = BagCalc.getStickerCount(orders, rackConfigs);
    }
    const qrCodeValues = [...Array(count).keys()]
      .map(i => `${qrBase}-${i + 1}`)
      .map(s => md5(s))
      .map(s => s.slice(0, 12));
    return qrCodeValues;
  }

  static getNumberOfBags(orders) {
    const useBags = false;
    const MEALS_PER_BAG = 4;

    let mealUnits = this.getSizeValue(orders);

    if (useBags) {
      return Math.ceil(mealUnits / MEALS_PER_BAG) || 1;
    } else {

      // // TEMP OVERRIDE BECAUSE NO 8 MEAL BOXES
      // if (7 <= mealUnits && mealUnits <= 8) {
      //   return 2;
      // }


      // TEMP OVERRIDE BECAUSE NO RED BOX
      // return Math.max(1, Math.ceil(mealUnits / 10))

      // standard box logic, presuming all box sizes available,
      // one sticker per 12 meals.
      return Math.max(1, Math.ceil(mealUnits / 12))


      // odd logic - when certain boxes were not available

      // 4 meals 1 sticker
      // 5/6 meals 2 stickers
      // 7-12 meals 2 stickers (no more red box)
      // 13 + 2 stickers too ( red + blue

      // if (mealUnits <= 4) {
      //   return 1;
      // } else if (mealUnits <= 6) {
      //   return 2;
      // } else if (mealUnits <= 12) {
      //   return 2;  // out of red boxes, so have to use 2 boxes
      // } else { // if total > 12
      //   return 2;
      // }
    }
  }

  static getSizeOfBags(/* orders */) {
    return 'standard';
    // let total = this.getSizeValue(orders);
    // if (total >= 8) {
    //   return 'large';
    // }
    // return 'small';
  }

  static getBins(orders) {
    const orderBins = {};
    orders.forEach(o => {
      if (o.bin) {
        let bins = (o.bin || '').split(',').filter(b => !!b);
        for (const bin of bins) {
          orderBins[bin] = 1
        }
      }
    });

    function extractLetterAndNumber(s) {
      // const regexp = /^([A-Za-z]).*?(\d+)?-(\d+)$/;
      // const [, rackLetter, rackNumber, binNumber] = (s || '').match(regexp);
      // return `${rackLetter}${rackNumber || ''}${rackNumber ? '.' : ''}${binNumber}`
      const parts = s.split('.');
      if (parts.length === 1) {
        return s;
      } else {
        const regexp = /^([A-Za-z\s]*)\.?([A-Za-z]).*-(\d+)$/;
        const [, rackName, rackNumber, binNumber] = (s || '').match(regexp);
        return `${rackName}`
          + (rackNumber ? `.${rackNumber}` : '')
          + `-${binNumber}`;
      }
    }

    return Object.keys(orderBins).map(extractLetterAndNumber).sort();
  }

  static getSizeValue(orders) {
    const categoryToSpaceMap = {
      'protein side': 1,
      'breakfast': 1,
      'single serve entree': 1,
      'snack': 0.5,
      // 'family size': 6 -- exclude
    }

    function isFruitCup(o) {
      return o.meal_id === 11308;
    }

    function getMealSpaceUsed(o) {
      if (o.containerSize){
        // console.log('container size', o.meal_id, o.order_type, o.containerSize);
        return o.containerSize;
      }
      if (o.category) {
        if (categoryToSpaceMap[o.category]) {
          return categoryToSpaceMap[o.category];
        } else {
          // logger.warn('category not found', o.category, o);
          return 0;
        }
      }
      return isFruitCup(o) ? 0.5 : 1;
    }


    let total = 0.0;
    // let mealValue = REGULAR_MEAL; //size === 'small' ? SMALL_MEAL : REGULAR_MEAL;

    for (const item of orders) {
      const mealValue = getMealSpaceUsed(item)
      total += item.quantity * mealValue;
    }

    if (total === 0 && orders.length > 1) {
      console.log('adding minimum of 1 sticker despite no space used', orders)
      total = 1;
    }
    return total;
  }
}
